import React from "react";

const NeueLinkRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.75 11.2505L16 10.0005C17.6569 8.34355 17.6569 5.6573 16 4.00045C14.3431 2.3436 11.6569 2.3436 10 4.00045L8.75 5.25045",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.24996 8.75L3.99996 10C2.34311 11.6569 2.34311 14.3431 3.99996 16C5.65681 17.6569 8.34306 17.6569 9.99996 16L11.25 14.75",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.25 7.75L7.75 12.25",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueLinkRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;